<template>
  <div v-show="isWarning" id="warn-window">
    <div class="mask"></div>
    <div class="warn-window">
      <div>
        <img src="/static/img/home/close.png" class="close-info" @click="handleClose">
        <h4>告警信息</h4>
        <p class="text">
          <img src="/static/img/home/warn.png" alt="">
          <span v-html="warningBase.msg"></span>
        </p>

        <div class="cam-box">
          <div v-if="videoUrl">
            <video id="id-video" ref="video" controls>
              您的浏览器不支持 video 标签。
            </video>
          </div>
          <div v-else>
            <p class="cam-mask">
              <span>附近暂无监控</span>
              <span>无法查看现场</span>
            </p>
            <!-- <p class="cam-top">&nbsp;&nbsp;监测点1 <span>{{nowTime}}</span></p> -->
            <img src="/static/img/home/camera.png" alt="">
          </div>
          <div>
            <div ref="charts" class="charts"></div>
          </div>
        </div>

        <ul class="device-info">
          <li>
            <span>设备名称：</span>
            <span class="code">{{ warningBase.deviceData.name4Company }}</span>
          </li>
          <li>
            <span>设备状态：</span>
            <span class="code">{{ warningBase.deviceData.online ? '正常' : '离线' }}</span>
          </li>
          <li>
            <span>报警类型：</span> <span class="code">{{ warningBase.type }}</span>
          </li>
          <!-- <li> <span>设备坐标：</span> <span class='code'>{{warningBase.deviceData.installLng}},{{warningBase.deviceData.installLat}}</span> </li> -->
        </ul>

        <div class="radio-box">
          <div class="box1">
            <span class="title">处置人：</span>
            <el-select v-model="handleId" placeholder="请选择">
              <el-option
                v-for="item in handleOptions"
                :key="item.id"
                :label="item.realname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>

          <div class="box1">
            <span class="title">处置状态：</span>
            <el-select v-model="handleState" placeholder="请选择">
              <el-option
                v-for="item in handleStateOption"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="radio-box">
          <span class="title">处置意见：</span>
          <el-select v-model="result" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </div>
        <div class="text-box">
          <span class="title">备注：</span>
          <el-input
            v-model="remarks"
            type="textarea"
            :rows="2"
            maxlength="100"
            placeholder="请输入内容"
          >
          </el-input>
        </div>
        <div class="btn-box">
          <el-popconfirm title="确认处理？" @onConfirm="handleSure(0)">
            <!-- <el-button slot="reference">删除</el-button> -->
            <el-button slot="reference" type="primary" round :loading="loading">
              处置
            </el-button>
          </el-popconfirm>
        </div>
        <!-- <span class='ps'>该条警告已通过短信的形式自动通知运维人员：袁欣欣、联系电话： 13805327329</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import Hls from 'hls.js'
import { formatDateTime } from '@/utils/objectUtil'
import { historyOption, realTimeOption } from './../config/index.js'
import { getList, getData, getHistoryData, getVideo } from './../service.js'

export default {
  name: 'EventList',
  components: {},
  props: {
    isWarning: {
      type: Boolean,
      default: true,
    },
    warningBase: {
      deviceId: null,
      type: Object,
      default: () => {
        return {
          is_warning: false,
          msg: '位于XXX位置的道路安全监测管理系统设备（设备名称）触发警告，请及时处理！',
          type: '',
          deviceData: {
            code: '',
            online: '1',
            installLng: '',
            installLat: '',
          },
          warningTime: '',
        }
      },
    },
  },
  data () {
    return {
      videoUrl: null,
      handleId: '',
      handleState: '',
      result: '',
      remarks: '',
      nowTime: '',
      textShow: false,
      loading: false,
      chart: null, // 加速度chart对象
      timmer: null,
      timmer_Timer: null,
      handleOptions: [],
      handleStateOption: [{ code: 1, name: '处置中' }, { code: 2, name: '处置完成' }],
      options: [
        {
          code: '护栏无明显变形，无需处理',
          name: '护栏无明显变形，无需处理',
        },
        {
          code: '护栏轻微变形，无需处理',
          name: '护栏轻微变形，无需处理',
        },
        {
          code: '护栏明显变形，无需处理',
          name: '护栏明显变形，无需处理',
        },
        {
          code: '护栏严重变形，需维修更换',
          name: '护栏严重变形，需维修更换',
        },
        {
          code: '护栏损坏，需维修更换',
          name: '护栏损坏，需维修更换',
        },
        {
          code: '终端传感器损坏，需更换',
          name: '终端传感器损坏，需更换',
        },
        {
          code: '终端传感器及护栏均损坏，需维修更换',
          name: '终端传感器及护栏均损坏，需维修更换',
        },
      ],
    }
  },
  watch: {
    isWarning (n) {
      if (n) {
        let { handleId, handleState, result, remarks, handleRealname } = this.warningBase
        // 处置中时
        handleState === 1 &&
          Object.assign(this, { handleId, handleState, result, remarks, handleRealname })
        handleState === 0 && this.initHandleData()
        this.videoUrl = null
        let num = this.warningBase.cameraNum
        if (num) {
          getVideo(num).then(res => {
            let src = res.data.url
            if (src) {
              this.videoUrl = src
              this.$nextTick(() => {
                this.playVideo(src)
              })
            }
          })
        }
      } else {
        this.initHandleData()
      }
    },
  },
  created () {
    this.getUserList()
  },
  beforeDestroy () {
    this.timmer_Timer && clearInterval(this.timmer_Timer)
    this.player && this.player.dispose()
  },
  mounted () {
    this.$nextTick(() => {
      this.timmer_Timer && clearInterval(this.timmer_Timer)
      this.timmer_Timer = setInterval(() => {
        this.nowTime = formatDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
      }, 1000)
    })
    this.watchId = this.$watch('warningBase.deviceId', deviceId => {
      let groupId = this.warningBase.deviceData.groupId
      if (groupId === 1) {
        let option = JSON.parse(JSON.stringify(historyOption))
        getHistoryData({ deviceId }).then(res => {
          if (res.code === 'success') {
            let xData = option.xAxis[0].data // 时间线`
            let xYData = option.series[0].data // 最大速度数据
            let yYData = option.series[1].data // 最大速度数据
            let zYData = option.series[2].data // 最大速度数据
            let list = res.data.list
            // let list = [ { 'time': '2020-12-01 10:46:30', 'x': 1, 'y': 2, 'z': 1 }, { 'time': '2020-12-01 10:46:35', 'x': 2, 'y': 3, 'z': 3 }, { 'time': '2020-12-01 10:46:40', 'x': 5, 'y': 7, 'z': 6 } ]
            list &&
              list.forEach(item => {
                let date = item.time ? formatDateTime(new Date(item.time), 'yy-MM-dd HH:mm:ss') : ''
                xData.push(date)
                xYData.push(item.x)
                yYData.push(item.y)
                zYData.push(item.z)
              })
            this.initChart(option)
          }
        })
      }
      if (groupId === 2) {
        let option = JSON.parse(JSON.stringify(realTimeOption))
        getData({ deviceId }).then(res => {
          if (res.code === 'success') {
            let { list } = res.data
            let xData = option.xAxis[0].data // 时间线
            let maxSpeedData = option.series[0].data // 最高车速
            let avgSpeedData = option.series[1].data // 平均车速
            let trafficFlow = option.series[2].data // 车流量
            list &&
              list.forEach(item => {
                xData.push(item.time ? item.time : '')
                maxSpeedData.push(item.maxSpeed)
                avgSpeedData.push(item.avgSpeed)
                trafficFlow.push(item.carFlow)
              })
            this.initChart(option)
          }
        })
      }
    })
  },

  destroyed () {
    this.watchId = null
  },
  methods: {
    playVideo (src) {
      const video = this.$refs.video
      let hls = new Hls()
      hls.loadSource(src)
      hls.attachMedia(video)
      hls.on(Hls.Events.MANIFEST_PARSED, function () {
        video.play()
      })
      this.hls = hls
    },

    destroyVideo () {
      const video = this.$refs.video
      if (video) {
        this.$refs.video.pause()
      }
      if (this.hls) {
        this.hls.destroy()
        this.hls = null
      }
    },
    // handleChange (e) {
    //   this.remarks = ''
    //   e === '3' ? this.textShow = true : this.textShow = false
    // },
    handleSure (e) {
      let name = this.handleOptions.find(({ id }) => id === this.handleId)

      this.loading = true
      let params = {
        id: this.warningBase.id,
        level: 1,
        type: this.warningBase.type,
        handleId: this.handleId,
        handleRealname: name ? name.realname : '',
        remarks: this.remarks,
        result: this.result,
        handleState: this.handleState,
      }

      this.$http
        .post('/api/device-warning-info/handle', params)
        .then(res => {
          this.loading = false
          if (res.code === 'success') {
            this.handleClose()
            this.$message({
              type: 'success',
              message: '已提交处理意见',
            })
            this.$emit('closeWarning')
          } else {
            this.$message({
              type: 'error',
              message: `提交失败${res.msg || ''}`,
            })
          }
        })
        .catch(err => {
          this.loading = false
        })
    },
    initChart (option) {
      // 加速度
      let echarts = this.$echarts.init(this.$refs.charts)
      echarts.clear()
      echarts.setOption(option)
    },
    handleClose () {
      this.$emit('warnCloseinfo')
      this.destroyVideo()
    },
    // moveData (chart, option, timmer) {
    //   // let self = this
    //   timmer = setInterval(function () {
    //     var axisData = (new Date()).toLocaleTimeString().replace(/^\D*/, '')
    //     var data = option.series[0].data
    //     let temp = Math.round(Math.random() * 41 + 200)

    //     data.shift()
    //     data.push(temp)

    //     option.xAxis.data.shift()
    //     option.xAxis.data.push(axisData)

    //     chart.setOption(option)
    //   }, 2000)
    // },
    // 用户列表数据
    async getUserList () {
      let {
        code,
        data: { list },
      } = await getList()
      if (code === 'success') this.handleOptions = list
    },
    // 初始化时的处置信息
    initHandleData () {
      let handleId = this.$store.state.id
      let name = this.handleOptions.find(({ id }) => id === handleId)
      this.handleRealname = name ? name.realname : ''
      this.handleId = handleId
      this.handleState = 2
      this.result = '护栏无明显变形，无需处理'
      this.remarks = ''
    },
  },
}
</script>

<style lang="less" scoped>
#warn-window {
  .mask {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99;
  }
  .warn-window {
    color: #fff;
    width: 692px;
    height: 590px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -346px;
    margin-top: -248px;
    z-index: 99;
    background: url('/static/img/home/warning.png') no-repeat;
    background-size: cover;
    box-shadow: 0px 0px 0px #fa0404;
    // box-shadow: 0px 0px 20px #49D1DE;
    animation: biling 0.8s ease-in infinite;
    > div {
      overflow: scroll;
      height: 100%;
    }
    .close-info {
      width: 30px;
      height: 30px;
      position: absolute;
      right: 20px;
      top: 13px;
    }
    &::after {
      content: '';
      position: absolute;
      bottom: -20px;
      left: 336px;
      width: 0;
      height: 0;
      border: 10px solid transparent;
      border-top-color: #041d55;
    }
    .el-radio {
      color: #fff;
      line-height: 30px;
    }
    /deep/.el-textarea__inner {
      background-color: transparent;
      border: 1px solid #19308a;
      color: #fff;
    }

    h4 {
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 24px;
    }

    /deep/ .text {
      padding: 5px 8px;
      width: 600px;
      // height: 40px;
      line-height: 30px;
      margin: 10px auto;
      background-color: rgba(250, 4, 4, 0.5);
      border: 2px solid rgba(250, 4, 4);
      border-radius: 5px;
      img {
        width: 30px;
        vertical-align: middle;
      }
      .warn-position {
        color: yellow;
      }
      display: -webkit-box;
      overflow: hidden;
      text-overflow: -o-ellipsis-lastline;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .cam-box {
      width: 640px;
      display: flex;
      justify-content: space-around;
      margin: 0px auto;
      video {
        object-fit: fill;
      }
      > div {
        width: 280px;
        height: 180px;
        // overflow: hidden;
        position: relative;
        .cam-top {
          position: absolute;
          width: 100%;
          color: #b5b2b2;
          line-height: 28px;
          background-color: rgba(0, 0, 0, 0.5);
          span {
            float: right;
            margin-right: 8px;
          }
        }
        .cam-mask {
          position: absolute;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.8);
          text-align: center;
          color: #b5b2b2;
          font-size: 18px;
          font-weight: bold;
          span {
            display: block;
            margin: 5px 0;
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
        video {
          width: 100%;
          height: 100%;
        }
      }
      .charts {
        width: 280px;
        height: 180px;
        border: 1px solid rgb(25, 48, 138);
        // background-color: rgba(25,48,138,.4);
      }
    }
    .device-info {
      width: 90%;
      margin: 10px auto;
      font-size: 14px;
      color: rgb(8, 117, 166);
      li {
        display: inline-block;
        width: 28%;
        margin-bottom: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        .code {
          color: #9ba5bb;
        }
        &:nth-child(3) {
          text-align: right;
          .code {
            color: #fa0404;
          }
        }
        &:nth-child(1) {
          width: 260px;
        }
        &:nth-child(4) {
          width: 500px;
        }
      }
    }
    .radio-box {
      width: 626px;
      margin: 0px auto;
      // border: 1px solid red;
      color: #fff;
      margin-bottom: 10px;
      .title {
        display: inline-block;
        width: 60px;
        font-size: 12px;
        color: rgb(8, 117, 166);
        margin-right: 10px;
      }
      .el-select {
        width: 85%;
      }
      /deep/.el-input__inner {
        background-color: transparent;
        border: 1px solid #19308a;
        color: #fff;
      }
    }
    .box1 {
      color: #fff;
      display: inline-block;
      .title {
        padding-left: 10px;
        margin-right: 0;
      }
      .el-select {
        width: 68%;
      }
      &:last-child {
        float: right;
      }
    }
    .text-box {
      margin: 0 auto;
      // margin-top: 20px;
      width: 626px;
      .title {
        display: inline-block;
        width: 60px;
        font-size: 12px;
        color: rgb(8, 117, 166);
        margin-right: 10px;
        text-align: right;
      }
      .el-textarea {
        width: 85%;
        vertical-align: top;
        color: #fff;
      }
    }
    .btn-box {
      text-align: right;
      margin-top: 15px;
      margin-right: 55px;
    }
    .ps {
      position: absolute;
      left: 20px;
      bottom: 25px;
      font-size: 12px;
      color: #999;
    }
    // .biling {
    //   position: absolute;
    //   top: 420px;
    //   left: 0px;
    //   img {
    //     width: 20px;
    //   }
    // }
    // .biling1 {
    //   position: absolute;
    //   top: 40px;
    //   right: -1px;
    //   transform: rotate(180deg);
    //   img {
    //     width: 10px;
    //   }
    // }
    @keyframes biling {
      from {
        box-shadow: 0px 0px 20px #fa0404;
      }
      50% {
        box-shadow: 0px 0px 0px #fa0404;
      }
      to {
        box-shadow: 0px 0px 20px #fa0404;
      }
    }
  }
}
</style>
